import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    pure: false,
    standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], callback: (item: any) => boolean): unknown {
    if (!items || !callback) {
      return items;
    }
    return items.filter(item => callback(item));
  }

}
